function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  className: "st0",
  d: "M30,37.5c-5.7895508,0-10.5-4.7099609-10.5-10.5V17c0-5.7895508,4.7104492-10.5,10.5-10.5 c5.7900391,0,10.5,4.7104492,10.5,10.5v10C40.5,32.7900391,35.7900391,37.5,30,37.5z M30,7.5c-5.2382812,0-9.5,4.2617188-9.5,9.5 v10c0,5.2382812,4.2617188,9.5,9.5,9.5s9.5-4.2617188,9.5-9.5V17C39.5,11.7617188,35.2382812,7.5,30,7.5z"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("polygon", {
  className: "st0",
  points: "31.5,56.1074219 35.2539062,52.3535156 34.546875,51.6464844 31.5,54.6933594 \t"
}), React.createElement("polygon", {
  className: "st0",
  points: "30.5,55.6933594 30.5,44.7998047 30.5,43 29.5,43 29.5,55.6932983 25.4536133,51.6464844  24.746582,52.3535156 30,57.6074219 30.5,57.1074219 \t"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M30,16c1.1046009,0,2-0.8954,2-2s-0.8953991-2-2-2s-2,0.8954-2,2S28.8953991,16,30,16z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    version: 1.1,
    id: "Layer_1",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      "enableBackground": "new 0 0 60 60"
    },
    xmlSpace: "preserve"
  }, props), _ref, _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/mouse-scroll.f792ab1d.svg";
export { SvgComponent as ReactComponent };